import React, { Component } from 'react';

import { roundNumber } from './../Helpers';
import AppStore from "../flux/AppStore";

class ProductPrice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customProduct: AppStore.getCustomProduct(),
    };

    // @todo 2018-03-01 Should be removed
    this.configurationCountToPrice = [
      0.00, // price for 0 patches
      29.50, // price for 1 patches
      29.50 + 10.00, // price for 2 patches
      29.50 + 10.00 + 20.00, // price for 3 patches
    ];

    this.onCustomProductChange = this.onCustomProductChange.bind(this);
  }

  componentDidMount() {
    AppStore.events.initCustomProduct.addListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.addListener(this.onCustomProductChange);
  }

  componentWillUnmount() {
    AppStore.events.initCustomProduct.removeListener(this.onCustomProductChange);
    AppStore.events.updateCustomProduct.removeListener(this.onCustomProductChange);
  }

  onCustomProductChange() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }
    onCustomProductInit() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  render() {
    return (
      <span>{this.state.customProduct ? parseFloat(roundNumber(this.getProductPrice())).toLocaleString(undefined, {minimumFractionDigits: 2}) : roundNumber(0)}</span>
    );
  }

  getProductPrice() {
    let totalPrice = this.state.customProduct.product.base_price;

    if (this.state.customProduct.perforated === true) {
      totalPrice += this.state.customProduct.product.perforated_price;
    }

    if (this.state.customProduct.custom_colored === true || this.state.customProduct.custom_colored === 1) {
      totalPrice += this.state.customProduct.product.customization_price + this.getFlattenedSpecificationWithPrice()
        .reduce((totalPrice, item) => totalPrice + item.price, 0);
    }

    if (this.state.customProduct.custom_fitted === true) {
      totalPrice += this.state.customProduct.product.custom_fit_price;
    }

    return totalPrice;
  }

  getFlattenedSpecificationWithPrice() {
    return Object.keys(this.state.customProduct.product.specification)
      .filter(specificationKey => {
        return this.state.customProduct.product.specification[specificationKey].active_combination !== null;
      })
      .map(specificationKey => {
        const activeCombination = this.state.customProduct.product.specification[specificationKey].combinations[
          this.state.customProduct.product.specification[specificationKey].active_combination
        ];
          //console.log(this.state.customProduct.product.specification);
        if (this.state.customProduct.product.specification[specificationKey].type === 'CUSTOM_PATCH') {
          // Instead of having a price for the combination, the custom patch
          // prices are a sum of all the patches (1 or more) that make the
          // specification part.
          // Example:
          //   Patch: Patch1 (leather) 59.95, Patch2 (transfer) 29.95 = 89.90
          //   Patch: Patch1 (leather) 59.95 = 59.95
          const combinationPrice = Object.keys(activeCombination.specification).filter(combinationSpecificationKey => {
            return activeCombination.specification[combinationSpecificationKey].modified;
          }).reduce((totalPrice, combinationSpecificationKey) => {
            // console.log(activeCombination.specification);
            return totalPrice + activeCombination.specification[combinationSpecificationKey].price;
          }, 0);

          return {
            key: specificationKey,
            price: combinationPrice,
          };
        }

        return {
          key: specificationKey,
          price: activeCombination.price,
        };
      }).filter(item => item.price > 0);
  }
}

export default ProductPrice;



// WEBPACK FOOTER //
// ./src/components/ProductPrice.js